import { jsxs, jsx } from "react/jsx-runtime";
import { Spinner } from "@flatfile/design-system";
import { Wrapper, LoadingSpinner } from "./Styles.js";
const ModalSpinner = ({ text }) => /* @__PURE__ */ jsxs(Wrapper, { children: [
  text,
  /* @__PURE__ */ jsx(LoadingSpinner, { children: /* @__PURE__ */ jsx(Spinner, {}) })
] });
export {
  ModalSpinner as default
};
